let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("713O5")).then(() => parcelRequire('bIsTX'));